import { ReceiptPayload } from '../interfaces/receipts.interfaces';
export const receiptValues: ReceiptPayload = {
  date_start: new Date(),
  date_end: new Date(),
  cajero: '',
  student_ci: '',
  payment_method_id: 0,
  filter: true,
};
